import i18n from '@fe/i18n/dist/i18n';
import { history } from '@store/history';
import { sendEvent } from '@utils/core/track';
import generatePath from '@utils/generatePath';
import AcIcon from 'ac-components/ac-icon';
import classnames from 'classnames';
import { Popup } from 'components/dialogs';
import Popover from 'components/popover';
import { isMobile } from 'components/select/utils';
import { COUNTRY_CONFIG, LANG } from 'constants/country';
import { COUNTRY_HOMEPAGE, EN_HOMEPAGE, INVITE_FRIENDS, LOGIN, MAIN_HOME, STEP_APPLY_TUTOR, TINT_APPLY_TUTOR } from 'constants/url';
import useResizeObserver from 'hooks/use-resize-observer';
import { useTranslation } from 'hooks/use-translation';
import React, { useEffect, useLayoutEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { NavLink, useHistory } from 'react-router-dom';
import globalStore, { GlobalStoreState } from 'states/app';
import { ConnectState } from 'states/connect';
import { HomeMenus, MenuItem, MenuList } from './const';
import Menu from './menu';
import styles from './styles.scss';

// const t = i18n.getMessages('header');
const IsMobile = isMobile();
let destory: Function | null;
const AvatarImg = 'https://web-data.zmlearn.com/image/qhnwXiVv7CcoLqmCnm2BsR/avatar_default_large.png';

enum Mode {
	aside = 'aside', //移动端
	drop = 'drop', //PC端
}

export default function NavMenu() {
	const { location } = useHistory();
	const { countryCode, user, token, local }: GlobalStoreState = useSelector((state: ConnectState) => state.app);
	const [mode, setMode] = useState<Mode>(IsMobile ? Mode.aside : Mode.drop);
	const [menu, setMenu] = useState<MenuItem>(HomeMenus[0]);
	const [visible, setVisible] = useState<boolean>(false);
	const [isShowLang, setVisibleLang] = useState<boolean>(false);
	const { pathname, search } = useHistory().location;
	const { t, transData } = useTranslation('header');
	const { width } = useResizeObserver();
	const onResizeHandle = () => {
		const width = document.body.clientWidth;
		setMode(width <= 768 ? Mode.aside : Mode.drop);
	};

	useLayoutEffect(() => {
		if (IsMobile) return;
		onResizeHandle();
		window.addEventListener('resize', onResizeHandle);
		return () => {
			window.removeEventListener('resize', onResizeHandle);
		};
	}, []);

	useEffect(() => {
		//  判断是否登录,登录状态下，不可以跳转到登录页面
		if (token?.isRegister && pathname === LOGIN && token && !token.isRegister) {
			history.replace(generatePath(MAIN_HOME));
		}
	}, []);

	useEffect(() => {
		//兼容之前6国落地页语言的问题
		const isEn = pathname === '/en' || COUNTRY_CONFIG.find((item) => item.countryCode === pathname);
		if (isEn) {
			i18n.setLocale('en');
			globalStore.setCountryCode('en');
		}
	}, [countryCode]);

	const menuList = useMemo(() => {
		const list: MenuItem[] = [];
		MenuList.forEach((item) => {
			if (item.login === false && token) return; // 未登录才展示
			if (item.login && !token) return; // 登录才展示
			if (item.name === 'setting' && token?.isRegister) return // 个人中心只有完善信息之后才有
			list.push({
				...item,
				path: item.path ? generatePath(item.path) : item.path,
				label: item.label || item.name,
			});
		});
		return list;
	}, [countryCode, token]);

	const homeList = useMemo(() => {
		const list: MenuItem[] = [];
		HomeMenus.forEach((item) => {
			if (item.login === false && token) return; // 未登录才展示
			if (item.login && !token) return; // 登录才展示
			list.push({
				...item,
				path: item.path ? generatePath(item.path) : item.path,
				label: item.label || item.name,
			});
		});
		return list;
	}, [countryCode, token]);

	const visibleList = useMemo(() => {
		const copyMenuList = [...menuList];
		// 删除不需要的菜单
		const homeMenu = menuList.shift();
		const showMenuList = copyMenuList.splice(3, 2);
		return [homeMenu, ...showMenuList, copyMenuList[copyMenuList.length - 1]];
	}, [menuList]);

	const menuItems = useMemo(() => {
		const copyMenuList = [...menuList];
		// 删除不需要的菜单
		copyMenuList.splice(2, 2);
		// copyMenuList.splice(copyMenuList.length - 1, 1);
		return copyMenuList;
	}, [menuList]);

	const onToggleVisible = (visible: boolean, menuName?: string) => {
		if (menuName === 'lang') {
			setVisibleLang(visible);
		} else {
			setVisible(visible);
		}
		if (visible && mode === Mode.aside) {
			document.body.classList.add(styles['ac-nav-menu-droped-body']);
		} else {
			document.body.classList.remove(styles['ac-nav-menu-droped-body']);
		}
	};

	const closeMenu = () => {
		destory && destory();
		destory = null;
		onToggleVisible(false);
	};

	const onSelectHandle = (menu: MenuItem) => {
		const { path, onClick, name } = menu;
		setMenu(menu);
		closeMenu();
		if (onClick) {
			if (name === 'logout') {
				onClick(t('profile'));
			} else {
				onClick();
			}
		}
		if (path) {
			// 跳转
			if (location.pathname === LOGIN && token) {
				history.replace(generatePath(path));
				return;
			}
			history.push(generatePath(path));
		}
	};

	const onShowMenu = () => {
		onToggleVisible(true);
		destory = Popup.show({
			content: (
				<div className={`${styles.aside} ${styles.nav_menu_popup}`}>
					<div className={styles.aside_title}>
						<AcIcon icon="icon_close" onClick={closeMenu} />
					</div>
					<Menu menu={menu} transData={transData} list={[...homeList, ...menuList]} onSelect={onSelectHandle} />
				</div>
			),
			width: '220px',
			mask: true,
			maskClosable: true,
			onDestroy: () => onToggleVisible(false),
		});
	};

	//语言切换
	const onSelectLang = (menu: MenuItem) => {
		i18n.setLocale(menu.code!);
		globalStore.setCountryCode(menu.code!);
		const path = pathname.split('/')[1];
		const ignorePath = [STEP_APPLY_TUTOR, TINT_APPLY_TUTOR, LOGIN];
		if (!ignorePath.includes(pathname)) {
			history.replace(pathname.replace(`/${path}`, `/${menu.code}`) + search);
		}
	};

	// 进入页面设置菜单选中状态
	useEffect(() => {
		const currentMenu = menuList.find((item) => {
			if (item.path) {
				return generatePath(item.path) === pathname;
			}
			return false;
		});
		if (currentMenu) {
			setMenu(currentMenu);
		}
	}, [menuList, pathname]);

	const renderChildren = () => {
		return (
			<>
				<div className={`${styles.user_info} ${token && !token?.isRegister ? styles.login : styles.unlogin}`}>
					<div className={styles.avatar}>
						<img src={user?.avatar || AvatarImg} alt="avatar" />
					</div>
					<span className={classnames(styles.icon, visible ? styles.droped : '')}>
						<AcIcon icon=" icon_dropdown" />
					</span>
				</div>
				{(!token || width < 768 || token?.isRegister) && (
					<div className={styles.more}>
						<span className={classnames(styles.title, visible ? styles.droped : '')}>{transData.more}</span>
						<span className={classnames(styles.icon, visible ? styles.droped : '')}>
							<AcIcon icon=" icon_dropdown" />
						</span>
					</div>
				)}
			</>
		);
	};
	const renderLang = () => {
		return (
			<>
				<div className={styles.lang}>
					<span className={styles.icon}>
						<AcIcon icon=" icon_language" />
					</span>
					<span className={classnames(styles.title, isShowLang ? styles.droped : '')}>
						{LANG.find((item) => item.code == local.split('-')[0])?.name}
					</span>
				</div>
			</>
		);
	};

	const getPathname = () => {
		const countryPath = COUNTRY_CONFIG.map((item) => '/' + item.countryCode);
		if (pathname === EN_HOMEPAGE) {
			return false;
		}
		return !countryPath.find((item) => item === pathname);
	};

	const renderMenu = () => {
		const list = visibleList.map((item: MenuItem) => {
			// eslint-disable-next-line array-callback-return
			if (!item.path) return;
			return (
				<NavLink
					key={item.name}
					to={item.path as string}
					activeClassName={styles['nav_active']}
					onClick={() => {
						setMenu(item);
					}}>
					<span className={styles.nav_item}>{transData[item.label]}</span>
				</NavLink>
			);
		});
		return list;
	};

	return (
		<div className={styles.nav_menu}>
			{token && !token.isRegister && (
				<NavLink className={styles.invite_nav} to={generatePath(INVITE_FRIENDS)}>
					<img src={transData.header_line} alt="invite" />
				</NavLink>
			)}
			{mode === Mode.drop && (
				<>
					{(!token || token?.isRegister) && renderMenu()}
					<Popover
						content={
							<div className={`${styles.drop} ${styles.nav_menu_popup}`}>
								<Menu
									menu={menu}
									transData={transData}
									list={token && !token?.isRegister ? [...homeList, ...menuList] : menuItems}
									onSelect={(menu: MenuItem) => {
										onSelectHandle(menu);
									}}
								/>
							</div>
						}
						mouseLeaveDelay={30}
						contentStyle={{ marginLeft: user ? 50 : 31 }}
						onVisibleChange={(visible: boolean) => {
							onToggleVisible(visible);
							visible && sendEvent({ eventId: 'ACW_nav_menuhover' });
						}}
						clickAutoHidden
						// forceVisible //调试用
					>
						<span className={styles.menu_bar}>{renderChildren()}</span>
					</Popover>
				</>
			)}
			{mode === Mode.aside && width <= 1192 && (
				<span className={styles.menu_bar} onClick={onShowMenu}>
					{renderChildren()}
				</span>
			)}
			{getPathname() && (
				<Popover
					content={
						<div className={classnames(styles.drop, styles.nav_menu_popup, styles.lang_popup)}>
							<Menu
								transData={transData}
								menu={LANG.find((item) => item.code == local.split('-')[0])}
								list={LANG}
								onSelect={onSelectLang}
							/>
						</div>
					}
					contentStyle={{ marginLeft: 27 }}
					mouseLeaveDelay={30}
					onVisibleChange={(visible: boolean) => {
						onToggleVisible(visible, 'lang');
					}}
					clickAutoHidden
					// forceVisible //调试用
				>
					<span className={styles.lang_bar}>{renderLang()}</span>
				</Popover>
			)}
		</div>
	);
}
